import React from "react";
import { Button, Space, Badge } from "antd";
import apiConfig from "../../../api_config.json";
import { useAppContext } from "../../../context";
import { useOrgDocumentsData } from "../../Documents/useOrgDocumentsData";
import DocumentsExplorer from "../../Documents/DocumentsExplorer";

// Nella vista di una singola org: niente filtro org, mappa o ricerca full-text.
// La copia resta attiva e riusa la selezione multipla dell'explorer globale.
const ORG_FEATURES = { orgFilter: false, map: false, fullText: false };

// Tab "Documenti" di un'organizzazione: riusa DocumentsExplorer con le funzioni
// non sensate per una singola org (filtro org, mappa) disattivate.
const OrgDocumenti = ({ orgId }) => {
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";
  const { docs, loading, error } = useOrgDocumentsData(orgId);

  // Azione org-specifica nel drawer di ingrandimento.
  const actions = (doc) => (
    <Button
      type="primary"
      target="_blank"
      rel="noopener noreferrer"
      href={`${apiConfig.ofcUrl[env]}/index.php?page=modificaTemplateDocumento&documentId=${doc.objectId}`}
    >
      Modifica su Eterno
    </Button>
  );

  return (
    <DocumentsExplorer
      docs={docs}
      loading={loading}
      error={error}
      features={ORG_FEATURES}
      actions={actions}
      showOrgLink={false}
      showFlags
      emptyText="Non ci sono documenti per questa organizzazione"
      renderHeader={(count) => (
        <div style={{ marginBottom: 16 }}>
          <Space>
            <span style={{ fontWeight: 600, fontSize: 16 }}>Documenti</span>
            <Badge overflowCount={5000} count={count} />
          </Space>
        </div>
      )}
    />
  );
};

export default OrgDocumenti;
